import { detectFromNavigator } from 'utilities/user-agent'

export const isServer = () => typeof window === 'undefined'

export function isMobile() {
  return detectFromNavigator().isMobile
}

export const hasTouch = () => {
  return (
    process.browser &&
    document.documentElement &&
    ('ontouchstart' in document.documentElement ||
      navigator.maxTouchPoints > 0 ||
      navigator.msMaxTouchPoints > 0)
  )
}

export const IS_PROD = process.env.APP_ENV === 'production'
export const IS_STAGING = process.env.APP_ENV === 'staging'
export const IS_DEV = process.env.APP_ENV === 'development'
